const map = require('lodash/fp/map');
const memoizer = require('../request-handler/utils/memoizer');

function parseResult(res) {
  if(!res){
    return null;
  }
  return JSON.stringify(res);
}

function serviceFactory({ api }) {

  const validateMultisignPayment = memoizer()(( inputParam, metaData) =>
    api.validateMultisignPayment( inputParam, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );
  const resumeMultisignPayment = memoizer()(( inputParam, metaData) =>
    api.resumeMultisignPayment( inputParam, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

   const fetchMultiSignNotification = memoizer()(( {inputParam, metaData}) =>
    api.fetchMultiSignNotification( inputParam, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  return {
    validateMultisignPayment,
    fetchMultiSignNotification,
    resumeMultisignPayment
  };

}

module.exports = serviceFactory;